import { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { createModal } from "../hooks/createModal";
import Menu from "../ui/Menu";
import Card from "../ui/Card";
import Label from "../ui/Label";
import ReportsCustomInventory from "../components/ReportsCustomInventory";
import Divider from "../ui/Divider";
import Space from "../ui/Space";
import Nav from "../ui/Nav";
import ProcessingList from "../components/ProcessingList";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import ProcessingDetails from "../components/ProcessingDetails";
import OrdersList from "../components/OrdersList";
import OrdersDetails from "../components/OrdersDetails";

export default function OrdersController(props) {

    const { controller = "", signal = {}, setController = () => { } } = props;

    const route = ROUTES.ORDERS.ORDERS;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [items, setItems] = useState([]);
    const [align, setAlign] = useState("auto");
    const [view, setView] = useState(true);
    const [edit, setEdit] = useState(false);
    const [filters, setFilters] = useState({ limit: 45, sort: "id" })
    const row_key = "order_id";

    const order_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { text: "Adj" },
        { text: "Cpy" },
        { text: "Del" },
        { text: "Edt" },
        { text: "@Edt" },
        { text: "Hst" },
        { text: "Indx" },
        { text: "Lbl" },
        { text: "Mass" },
        { text: "New" },
        { text: "Ord" },
        { text: "Prt" },
        { text: "Rsv" },
        { text: "Srch" },
        { text: "Trf" },
        { text: "View" },
        { text: "Wrev" },
        { text: "Zret" },
      
    ]

    useEffect(() => {
        window.bm_state.value = route;
        const cleanup = listen(controller, route, order_nav);
        return cleanup;
    }, [order_nav, selected])




    return (
        <div className="controller">
            <div style={{ height: "calc(100vh - 140px)", minHeight: "511px", gap: "15px" }}>
                <OrdersDetails controller={controller} setSelectedItem={setSelectedItem} setSelected={setSelected} items={items} setItems={setItems} selected={selected} />
                <div className="shim" />
                <OrdersList
                    controller={controller}
                    loading={loading}
                    setLoading={setLoading}
                    route={route}
                    data={data}
                    setData={setData}
                    selected={selected}
                    setSelected={setSelected}
                    signal={signal}
                    align={align}
                    setAlign={setAlign}
                    view={view}
                    filters={filters}
                    setFilters={setFilters}
                    row_key={row_key}
                />
              
            </div>
              <div className="shim" />
                <Divider />
                <div style={{ 'height': "30px" }}>
                    <Space style={{ "padding": "0px 15px" }}>
                        <Nav nav={order_nav} />
                    </Space>
                </div>
            
        </div>
    )
}


